import React, {Component} from "react";

import {withTranslation} from 'react-i18next';

import {Button, ButtonVariant} from "@amzn/stencil-react-components/button";
import {Col} from "@amzn/stencil-react-components/layout";

import {Popover} from '@amzn/stencil-react-components/popover';
import {PageHeaderDropdownButton} from "@amzn/stencil-react-components/page";

class ActionButton extends Component {
  constructor(props) {
    super(props);
  }

  createActionButton = () => {
    if (this.props.options) {
      return (
        <Popover
          triggerText={this.props.title}
          triggerButtonProps={{
            hasOutline: true,
            style: {width: "fit-content"}
          }}
          maxWidth="100vw"
        >
          {() => (
            this.props.options.map((element, index) => (
              <PageHeaderDropdownButton
                aria-label={`${element.label}`}
                dataTestId={element.label}
                key={index}
                onClick={() => this.props.onMenuOptionClick(element)}
              >
                {element.label}
              </PageHeaderDropdownButton>
            ))
          )}
        </Popover>
      );
    }

    return (
      <Button
        id={this.props.title}
        aria-label={`${this.props.title}`}
        variant={ButtonVariant.Secondary}
        onClick={this.props.onClick}
        style={{width: "fit-content"}}
      >
        <Col alignItems="center">
          {this.props.title}
        </Col>
      </Button>
    );
  }

  render() {
    return this.createActionButton();
  }
}

export default withTranslation('translationsV2')(ActionButton);
